/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfielddoorprice3Inputs */

const en_ticketsfielddoorprice3 = /** @type {(inputs: Ticketsfielddoorprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay at the door`)
};

const de_ticketsfielddoorprice3 = /** @type {(inputs: Ticketsfielddoorprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor Ort zu zahlen`)
};

/**
* | output |
* | --- |
* | "Pay at the door" |
*
* @param {Ticketsfielddoorprice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfielddoorprice3 = /** @type {((inputs?: Ticketsfielddoorprice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfielddoorprice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfielddoorprice3(inputs)
	return de_ticketsfielddoorprice3(inputs)
});
export { ticketsfielddoorprice3 as "ticketsFieldDoorPrice" }